import { Select, SelectProps } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDebounce } from "use-debounce";
import { httpRequest } from "../helpers/api";
import { BaseResponsePaginationProps } from "../types/config.type";

interface ProvinceProperties {
	provinceId: number;
	provinceName: string;
}

interface CityProperties {
	cityId: number;
	cityName: string;
	province?: ProvinceProperties;
}

interface Props extends SelectProps {}
const SelectCityFilter: React.FC<Props> = ({ ...props }) => {
	const abortController = useRef(new AbortController());
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [search, setSearch] = useState("");
	const [cityList, setCityList] = useState<CityProperties[]>([]);

	const [debouncedSearch] = useDebounce(search, 500);

	const _handleSearchCity = async (query: string) => {
		if (query) {
			try {
				abortController.current.abort();
				abortController.current = new AbortController();
				setIsLoading(true);
				const { data } = await httpRequest.get<BaseResponsePaginationProps<CityProperties>>("geodata/cities", {
					params: {
						search: query,
						limit: 20,
						includeData: "province",
					},
					signal: abortController.current.signal,
				});
				setCityList(data.payload.results);
			} catch (error) {}
			setIsLoading(false);
		}
	};

	useEffect(() => {
		_handleSearchCity(debouncedSearch);
	}, [debouncedSearch]);

	return (
		<Select
			virtual={false}
			loading={isLoading}
			placeholder="Cari Kota"
			showSearch
			defaultActiveFirstOption={false}
			filterOption={false}
			searchValue={search}
			onSearch={(v) => setSearch(v)}
			notFoundContent={null}
			options={cityList.map((row) => ({
				value: row.cityName + ", " + row.province?.provinceName,
				label: row.cityName + ", " + row.province?.provinceName,
			}))}
			{...props}
		/>
	);
};
export default SelectCityFilter;
